import {ServerBizApi} from '../../../src/group-cloud/network/ServerBizApi';

let Server = {install: function(Vue, options) {

  Vue.prototype.$post = async function(uri, data = {}) {
    return await ServerBizApi.send(uri, data);
  };

}};


export default Server;
